<template>
  <div class="align-center">
    <p class="display-1 primary--text text-center">Unser Team</p>

    <template v-for="mitarbeiter in mitarbeiter">
      <v-card
        :key="mitarbeiter.name"
        class="mx-auto"
        max-width="500"
        outlined
      >
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-2">{{mitarbeiter.position}}</div>
            <v-list-item-title class="mb-1">{{mitarbeiter.name}}</v-list-item-title>
            <v-list-item-subtitle v-if="mitarbeiter.durchwahl">Durchwahl: {{mitarbeiter.durchwahl}} </v-list-item-subtitle>
            <a :href="'mailto:' + mitarbeiter.mail">
              {{mitarbeiter.mail}}
            </a>
          </v-list-item-content>

          <v-list-item-avatar v-if="mitarbeiter.bild" width="120" height="130" class="hidden-xs-only" tile>
            <v-img :src="mitarbeiter.bild"/>
          </v-list-item-avatar>

          <v-list-item-avatar v-if="mitarbeiter.bild" width="65" height="70" class="hidden-sm-and-up" tile>
            <v-img :src="mitarbeiter.bild"/>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </template>

    <div class="mx-md-12 px-sm-12" align="justify">
      <p class="text-center title primary--text mt-3 mb-1">Unser Team</p>

      <p>
        Damit wir uns bestmöglich um die uns anvertrauten Bewohnerinnen und Bewohner kümmern können, 
        setzt sich unser Team aus gut ausgebildeten Mitarbeitenden zusammen. 
        Für ein gutes Zusammenarbeiten brauchen wir (diplomierte) Gesundheits- und Krankenpflegepersonen, 
        Fachsozialbetreuerinnen und -betreuer, umsichtige Reinigungskräfte und erfahrenen Küchenkräfte. 
        Unser Personal kann nicht nur auf eine gute Ausbildung sondern zum Teil auch auf Berufserfahrung in 
        anderen Berufen und wertvolle Lebenserfahrung zurückgreifen. Von diesen Voraussetzungen profitieren 
        vor allem unsere Bewohnerinnen und Bewohner insbesondere bei Beschäftigungsangeboten.
      </p>
    </div>

    <div class="text-center">
      <p>
        <strong>Beim Arbeiten helfen wir zusammen</strong>
      </p>
      
      <img
      class="hidden-sm-and-down"
      width="50%"
      :src="require('@/assets/Ueber_Uns/Unser_Team/Miteinander.jpg')"
      />

      <img
      class="hidden-md-and-up"
      width="100%"
      :src="require('@/assets/Ueber_Uns/Unser_Team/Miteinander.jpg')"
      />
    </div>

    <div class="mx-md-12 px-sm-12" align="justify">
      <p class="text-center title primary--text mt-3 mb-1">Ehrenamtliche Mitarbeiter</p>

      <p>
        Unsere Mitarbeiterinnen und Mitarbeiter werden von vielen ehrenamtlich Mitarbeitenden unterstützt. Die Bandbreite in dieser freiwilligen Unterstützung reicht von fast täglichem Helfen zu den Stoßzeiten – wie rund um das Mittagessen, bis zu Unterstützungen die einmal im Jahr geleistet werden.
        Regelmäßig kommen unsere ehrenamtlich Mitarbeitenden zu Gesprächen, Kaffeerunden, zum Singen oder einfach zum Zuhören. Für große Veranstaltungen sind wir dankbar, dass wir von vielen helfenden Händen genau für diesen speziellen Anlass unterstützt werden.
        Sollten Sie Interesse an der ehrenamtlichen Mitarbeit haben, kontaktieren Sie uns. Gerne können Sie sich auch an unsere Freiwilligenkoordinatorin Bettina Aichinger im Wohnbereich 3 wenden.
      </p>
    </div>

    <div class="mx-md-12 px-sm-12" align="justify">
      <p class="text-center title primary--text mt-3 mb-1">E-Qalin Qualitätsmanagement</p>

      <p>
        Seit 2017 haben wir uns intensiv - unter Einbindung unserer Mitarbeitenden - mit dem Thema Qualitätsmanagement beschäftigt. 
        Durch die Einführung von E-Qalin im Jänner 2019 können wir den Aufenthalt im Haus, sowohl für Bewohnerinnen und Bewohner, 
        als auch für unser Personal, attraktiver gestalten. Mit dem neuen Qualitätsmanagement werden nicht nur Abwicklungen 
        für das Personal verbessert, sondern auch die körperliche und geistige Fitness der Bewohnerinnen und Bewohner gefördert.
      </p>
    </div>
  </div>

  
</template>

<script>
  export default {
    name: 'Unser_Team',

    data() {
        return {
            mitarbeiter: [
              {
                name: "Mag. Manuela Winklinger",
                bild: require('@/assets/Ueber_Uns/Unser_Team/2018-Winklinger.jpg'),
                durchwahl: "50",
                position: "Heimleitung",
                mail: "office@altenheim-frankenburg.at"
              },
              {
                name: "Martina Aschenberger-Berner",
                durchwahl: "14",
                position: "Sekretariat",
                mail: "office@altenheim-frankenburg.at"
              },
              {
                name: "DGKP. Manuela Dax",
                bild: require('@/assets/Ueber_Uns/Unser_Team/2014-dax.jpg'),
                durchwahl: "60",
                position: "Pflegedienstleitung",
                mail: "manuela.dax@altenheim-frankenburg.at"
              },
              {
                name: "Günther Hunara",
                bild: require('@/assets/Ueber_Uns/Unser_Team/2014-hunara.jpg'),
                durchwahl: "51",
                position: "Hausmeister",
                mail: "guenther.hunara@altenheim-frankenburg.at"
              },
              {
                name: "Herbert Reichinger",
                durchwahl: "30",
                position: "Küchenleitung",
                mail: "kuechenleitung@altenheim-frankenburg.at"
              },
              {
                name: "DGKP. ",
                position: "Gruppenleiterin",
              },
              {
                name: "DGKP. Christine Zoister",
                position: "Gruppenleiterin",
              },
              {
                name: "DGKP. Gerlinde Hüttl",
                position: "Gruppenleiterin",
              },
            ]
        }
    }
  }
</script>

<style>
.v-card{
  margin-bottom: 2rem;
}

</style>